import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  gap: 10px;
  height: 42px;
  border: 1px solid #e6e8f0;
  background: #f9fafc;
  border-radius: 8px;
  user-select: none;
`;

interface IText {
  disabled?: boolean;
}

export const Text = styled.div<IText>`
  font-weight: 500;
  font-size: 14px;
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#474d66')};
`;

interface ICount {
  disabled?: boolean;
}

export const Count = styled.div<ICount>`
  font-weight: 500;
  font-size: 14px;
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#474d66')};
  width: 20px;
  text-align: center;
`;

interface IIcon {
  disabled?: boolean;
}

export const Icon = styled.div<IIcon>`
  height: 20px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;
